import { render, staticRenderFns } from "./DocumentsTypeFilter.vue?vue&type=template&id=73ad87b0&scoped=true&"
import script from "./DocumentsTypeFilter.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./DocumentsTypeFilter.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./DocumentsTypeFilter.vue?vue&type=style&index=0&id=73ad87b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ad87b0",
  null
  
)

export default component.exports